import React from 'react';

import { MdmObjectDto, useGetObjectsByProjectQuery } from 'gql/generated/types';
import { useParams } from 'react-router-dom';
import MapWrapper from '../components/MapWrapper';
import ObjectMapContent from '../components/ObjectMapContent';

const ObjectMap = () => {
  const { projectId } = useParams();
  const { data } = useGetObjectsByProjectQuery({ variables: { id: projectId! }, skip: !projectId });
  return (
      <MapWrapper>
        <ObjectMapContent objects={(data?.mdmObjectsByProjectId ?? []) as MdmObjectDto[]} />
      </MapWrapper>
  );
}

export default ObjectMap
